import fetch, { PUBLIC_REQUEST_KEY } from 'auth/FetchInterceptor'
import { message } from 'antd';
import { WSS_BASE_URL } from 'configs/AppConfig'
import { TIMEOUT } from '../auth/FetchInterceptor'
import {createIntl, createIntlCache} from 'react-intl'
import store from '../redux/store/index'
import moment from 'moment'
import { setDiscrepanciesCount, setHoursEndorsementCount, setHasNotPresentReports, setNotifications, setSectionReload } from 'redux/actions/Session';
 
export const ERROR_DURATION = 3
export const SUCCESS_DURATION = 4
const key = 'updatable';

const cache = createIntlCache()

class SamacLib {

	static currentAppLocale;
	static intl;
	static menuInstance;

	static history;

	static setCurrentAppLocale(locale)
	{
		SamacLib.currentAppLocale = locale;
		SamacLib.intl = createIntl({
			locale: SamacLib.currentAppLocale.locale,
			messages: SamacLib.currentAppLocale.messages,
		}, cache)
	}

	static GetShortDateFormat()
	{
		return (SamacLib.intl.formatMessage({id: "system.format.shortdate"}));
	}

	static GetDateFormat()
	{
		return (SamacLib.intl.formatMessage({id: "system.format.date"}));
	}

	static GetTimeFormat()
	{
		return (SamacLib.intl.formatMessage({id: "system.format.time"}));
	}

	static GetDateTimeFormat()
	{
		return (SamacLib.intl.formatMessage({id: "system.format.dateTime"}));
	}

	static GetDateFormatWDay()
	{
		return (SamacLib.intl.formatMessage({id: "system.format.dateWDay"}));
	}

	static GetLanguage(key)
	{
		return (SamacLib.intl.formatMessage({id: key}));
	}

	static GetMomentIfValid(dt)
	{
		if(dt !== null && dt !== undefined && dt !== "")
		{
			let date = moment(dt);
			let isValid = date.isValid() && !(date.date() === 1 && date.month() === 0 && date.year() === 1970)
			return isValid ? date : undefined
		}
		else
		{
			return undefined
		}
	}
	static GetDateIfValid(dt)
	{
		if(dt !== null && dt !== undefined && dt !== "")
		{
			let date = moment(dt);
			let isValid = date.isValid() && !(date.date() === 1 && date.month() === 0 && date.year() === 1970)
			return isValid ? date.format(SamacLib.GetDateFormat()) : ""
		}
		else
		{
			return ''
		}
	}

	static GetDateTimeIfValid(dt)
	{
		if(dt !== null)
		{
			let date = moment(dt);
			let isValid = date.isValid() && !(date.date() === 1 && date.month() === 0 && date.year() === 1970)
			return isValid ? date.format(SamacLib.GetDateTimeFormat()) : ""
		}
		else
		{
			return ''
		}
	}

	static CapitalizeFirstLetter = (string) => {
		return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
	}

	static ReloadSessionData(){
		
		SamacLib.GetRequest("users/session").then((body) =>
		{
			if(body !== undefined)
			{
				store.dispatch(setHoursEndorsementCount(body.hours_endorsement_count));
				store.dispatch(setDiscrepanciesCount(body.discrepancies_count));
				store.dispatch(setHasNotPresentReports(body.has_notclosed_reports));
				store.dispatch(setNotifications(body.notifications));
			}
			
		});
	}

	static ForceSectionReload = (section) => {
		store.dispatch(setSectionReload(section));
	}

	static CreateWebSocket(socketId){
		let ws = new WebSocket(WSS_BASE_URL+"?socketId="+socketId);
		return ws;
	}

	static GetRequest(url, params, publicRequest = false) {
		return new Promise(function(resolve, reject)
		{
			let headers = {};
			if(publicRequest)
			{
				headers[PUBLIC_REQUEST_KEY] = true
			}
			
			fetch(url, {method: 'GET', headers: headers, timeout: TIMEOUT, params: params})
			.then(body => {
			   if(body !== undefined)
			   {
				  resolve(body.data);
			   }
			})
			.catch((err) => {
				reject(err);
			})
		})
	}

	static DownloadFileRequest(url, params) {
		return new Promise(function(resolve, reject)
		{
			fetch(url, {method: 'GET', timeout: TIMEOUT, params: params, responseType: "blob"})
			.then(body => 
			{
				var blob = body.data;
				var filename = "";
				var disposition = body.headers['content-disposition'];
				if (disposition && disposition.indexOf('attachment') !== -1) {
					var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
					var matches = filenameRegex.exec(disposition);
					if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
				}

				if (typeof window.navigator.msSaveBlob !== 'undefined') {
					// IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
					window.navigator.msSaveBlob(blob, filename);
				} else {
					var URL = window.URL || window.webkitURL;
					var downloadUrl = URL.createObjectURL(blob);

					if (filename) {
						// use HTML5 a[download] attribute to specify filename
						var a = document.createElement("a");
						// safari doesn't support this yet
						if (typeof a.download === 'undefined') {
							window.location.href = downloadUrl;
						} else {
							a.href = downloadUrl;
							a.download = filename;
							document.body.appendChild(a);
							a.click();
						}
					} else {
						window.location.href = downloadUrl;
					}

					setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
				}
			});
        });
	}

	static DownloadFileRequest2(url, params) {
		return new Promise(function(resolve, reject)
		{
			fetch(url, {method: 'GET', timeout: TIMEOUT, params: params})
			.then(body => {
				let fileName = "REPORT.pdf"
			   	let disposition = body.headers['content-disposition'];
				if (disposition) {
					var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
					var matches = filenameRegex.exec(disposition);
					fileName = matches[0].replace('filename=','')
				}
			   	if(body !== undefined)
			   	{
				  resolve({file: body.data, fileName: fileName});
			  	}
			})
			.catch((err) => {
				reject(err);
			})
		})
	}

	static PostRequest(url, data, silent, publicRequest = false) {
		return new Promise(function(resolve, reject)
		{
			silent = (silent === true) ? true : false

			let headers = {};
			if(publicRequest)
			{
				headers[PUBLIC_REQUEST_KEY] = true
			}
			
			if(!silent)
			{
				message.loading({ content: 'Aggiornamento dati...', key, duration: TIMEOUT/1000 });
			}
			fetch(url, {method: 'POST', headers: headers, data, timeout: TIMEOUT})
			.then((data) => {
				if(!silent)
				{
					SamacLib.HandleResponse(data.data);
				}
				resolve(data.data);
			})
			.catch((err) => {
				reject(err);
			})
			
		})
	}

	static PutRequest(url, data, overrideHandle = false) {
		return new Promise(function(resolve, reject)
		{
			message.loading({ content: 'Aggiornamento dati...', key, duration: overrideHandle ? 1 : TIMEOUT/1000 });
			fetch(url, {method: 'PUT', data, timeout: TIMEOUT})
			.then((data) => {
				if(!overrideHandle)
				{
					SamacLib.HandleResponse(data.data);
				}
				resolve(data.data);
			})
			.catch((err) => {
				reject(err);
			})
			
		})
	}

	static DeleteRequest(url, data, overrideHandle = false) {
		return new Promise(function(resolve, reject)
		{
			message.loading({ content: 'Aggiornamento dati...', key, duration: overrideHandle ? 1 : TIMEOUT/1000 });
			fetch(url, {method: 'DELETE', data, timeout: TIMEOUT})
			.then((data) => {
				if(!overrideHandle)
				{
					SamacLib.HandleResponse(data.data);
				}
				resolve(data.data);
			})
			.catch((err) => {
				reject(err);
			})
			
		})
	}

	static FileRequest(url, params, fileType = "PDF") {
		return new Promise(function(resolve, reject)
		{
			let contentType = "application/pdf"
			switch(fileType)
			{
				default:
				case "PDF": contentType = "application/pdf"; break;
				case "EXCEL": contentType = "application/vnd.ms-excel"; break;
			}

			fetch(url, {method: 'GET', params: params, timeout: TIMEOUT, responseType: "arraybuffer"})
			.then((blob) => {
				const file = new Blob([blob.data], { type: contentType });

				//file.ContentDisposition = "inline; filename=REPORT";

				const fileURL = URL.createObjectURL(file, "");
				
				resolve(fileURL);
			})
			.catch((err) => {
				reject(err);
			})
			
		})
	}

	static FileRequestDownload(url, params, fileType = "PDF", fileName = "download") {
		return new Promise(function(resolve, reject)
		{
			let contentType = "application/pdf"
			let extension = ".pdf"
			switch(fileType)
			{
				default:
				case "PDF": 
					contentType = "application/pdf"; 
					extension = ".pdf";
					break;
				case "EXCEL": 
					contentType = "application/vnd.ms-excel"; 
					extension = ".xlsx";
					break;
			}

			fetch(url, {method: 'GET', params: params, timeout: TIMEOUT, responseType: "arraybuffer"})
			.then((blob) => {
				const file = new Blob([blob.data], { type: contentType });

				SamacLib.saveFile(file, fileName + extension);
				resolve();
			})
			.catch((err) => {
				reject(err);
			})
			
		})
	}

	static saveFile(blob, filename) {
		if (window.navigator.msSaveOrOpenBlob) {
		  window.navigator.msSaveOrOpenBlob(blob, filename);
		} else {
		  const a = document.createElement('a');
		  document.body.appendChild(a);
		  const url = window.URL.createObjectURL(blob);
		  a.href = url;
		  a.download = filename;
		  a.click();
		  setTimeout(() => {
			window.URL.revokeObjectURL(url);
			document.body.removeChild(a);
		  }, 0)
		}
	  }

	static HandleResponse(data)
	{
		let resp = {
			status: 0, //0: unknown, 1: success, 2: error, 3: warning
			message: "errGeneric"
		}

		if(data?.status !== undefined && data?.message !== undefined)
		{
			resp.status = data.status;
			resp.message = data.message;
		}

		let html = SamacLib.GetLanguage(`backendMsg.${resp.message}`);

		switch(resp.status)
		{
			default:
				message.info({ content: "UNKNOWN RESPONSE", key, duration: ERROR_DURATION })
				break;
			case 1:
				message.success({ content: html, key, duration: ERROR_DURATION });
				break;
			case 2:
				message.error({ content: html, key, duration: ERROR_DURATION })
				break;
			case 3:
				message.warning({ content: html, key, duration: SUCCESS_DURATION });
				break;
		}
	}
}

export default SamacLib;